export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tworzenie widżetu dla"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generuj"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Płatność w"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kwota płatności"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Działania w przypadku sukcesu"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Działania w przypadku niepowodzenia"])}
}